import { render, staticRenderFns } from "./ExpenseCategoryForm.vue?vue&type=template&id=bfadf4d4&scoped=true&"
import script from "./ExpenseCategoryForm.vue?vue&type=script&lang=ts&"
export * from "./ExpenseCategoryForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfadf4d4",
  null
  
)

export default component.exports